import { useEffect, useState } from "react";

const DEFAULT_DURATION = 120;

const useModalTransition = (isOpen, duration = DEFAULT_DURATION) => {
  const [shouldRender, setShouldRender] = useState(Boolean(isOpen));
  const [isClosing, setIsClosing] = useState(false);
  const isVisible = shouldRender || Boolean(isOpen);

  useEffect(() => {
    let timeoutId;

    if (isOpen) {
      if (!shouldRender) {
        setShouldRender(true);
      }
      setIsClosing(false);
      return undefined;
    }

    if (!shouldRender) {
      return undefined;
    }

    setIsClosing(true);
    timeoutId = setTimeout(() => {
      setShouldRender(false);
      setIsClosing(false);
    }, duration);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [duration, isOpen, shouldRender]);

  return { shouldRender: isVisible, isClosing };
};

export default useModalTransition;
